<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Alert } from "@getprovi/craft-svelte";
  import { DeliveryTruckSolid, ShoppingBagSolid } from "@getprovi/craft-svelte-icons";
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";
  import { startCase, toLower } from "lodash";

  export let distributor = null;
  export let productLine = null;
  export let products = [];

  const dispatch = createEventDispatcher();

  const isPickupOnly = distributor?.fulfillment_model === "pickup_only";
  const primaryLabel = isPickupOnly ? "Change Store" : "View Options";

  function primaryClick(): void {
    dispatch("openDrawer", { distributor, productLine, products });
  }

  $: distributorId = distributor?.id || distributor?.distributor_id;
  $: fulfillmentMethod = $RetailerFulfillmentMethodsStore[distributorId];
  $: warehouseName = fulfillmentMethod?.warehouse?.name
    ? startCase(toLower(fulfillmentMethod?.warehouse?.name))
    : "Pickup location";
</script>

<div class="craft">
  {#if !fulfillmentMethod?.warehouse_id && !isPickupOnly}
    <Alert title="Deliver" iconName={DeliveryTruckSolid} {primaryLabel} {primaryClick}>
      to {$CurrentRetailerStore.name}
    </Alert>
  {:else}
    <Alert title="Pickup" iconName={ShoppingBagSolid} {primaryLabel} {primaryClick}>
      from {warehouseName}
    </Alert>
  {/if}
</div>
